import { render } from "./ProjectEditDraft.vue?vue&type=template&id=3256d657&scoped=true"
import script from "./ProjectEditDraft.vue?vue&type=script&lang=js"
export * from "./ProjectEditDraft.vue?vue&type=script&lang=js"

import "./ProjectEditDraft.vue?vue&type=style&index=0&id=3256d657&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3256d657"]])

export default __exports__